<template>
<div class="w-100 h-100 bg-cover p-relative" :style="{backgroundImage: 'url('+ bgStyle +')'}">
  <h2 class="d-md-none mobile-section-title text-white">RESERVATION</h2>
  <div class="container pt-6 pl-6 pt-md-5 h-100 text-white">
    <div class="py-md-4">
    </div>
    <h2 class="font-size-2_5rem tracking-1 text-center d-none d-md-block">RESERVATION</h2>  
    <div class="row mt-5">
      <div class="col-md-6 col-lg-5 col-xl-4 offset-md-6">
        
        <h4 class="h2 mt-md-5">19時以降の<br class="d-md-none">ご案内について</h4>
        <p class="text-justify h5 xs-h6 line-height-1_8 mb-5 mt-5 mt-md-4">
          営業終了後の19時以降につきましては、ご予約制で香りをお楽しみいただけるお時間とさせていただいております。ご希望のお客様は下記お問い合わせにてご希望の日時をご記載の上ご連絡ください。
        </p>
        <a href="https://docs.google.com/forms/d/e/1FAIpQLSeT0j_KNGoYe_zqpcTZW8xofgpdY2oFu8-CeBj05thFnq6_VQ/viewform?usp=sf_link" target="_blank" class="btn btn-layered">
          <span>お問い合わせ</span>
          お問い合わせ
        </a>
      </div>
    </div>
  </div>
</div>

</template>

<script>
import bg from '@/assets/images/bg-reservation.jpg'

export default {
  computed: {
    bgStyle() {
      return bg
    }
  }
  
}
</script>

<style lang="scss" scoped>
.xs-h6 {
  @media screen and(max-width: 576px) {
    font-size: 0.85rem;
  }
}
</style>